import React, { useState } from 'react'
import PropTypes from 'prop-types'
import LocationDropdown from './locationDropdown'
import { format, addDays } from 'date-fns'

const Hotels = ({ agentCode, location }) => {
  const defaultArrivalDate = format(addDays(new Date(), 1), 'yyyy-MM-dd')
  const [isSecondRoom, secondRoom] = useState(false)

  return (
    <form
      className='relative mx-auto max-w-screen-xl rounded bg-orange-500 p-4 shadow-lg'
      method='get'
      rel='sponsored'
      acceptCharset='UTF-8'
      action='https://trip.holidayextras.co.uk/airporthotels/c/availability'>
      <input name='agentgroup' type='hidden' defaultValue='SZ' />
      <input name='channel' type='hidden' defaultValue='I' />
      <input name='agent' type='hidden' defaultValue={agentCode || 'WX372'} />
      <input name='request' type='hidden' defaultValue='21' />
      <input name='profile' type='hidden' defaultValue='p4less' />
      <input name='domain' type='hidden' defaultValue='secure.parking4less.com' />
      <input name='rule_set' type='hidden' defaultValue='parking4less' />
      <input name='lang' type='hidden' defaultValue='en' />
      <input name='product' type='hidden' defaultValue='ho' />
      <input name='selectProduct' type='hidden' defaultValue='ho' />
      <input name='Referer' type='hidden' defaultValue='https://www.parking4less.com/' />
      <input name='form_dirty' type='hidden' defaultValue='0' />
      <input name='numCarParking' type='hidden' defaultValue='0' />
      <input name='nights' type='hidden' defaultValue='1' />

      <div className='-mt-3 items-start lg:flex'>
        <div className='relative w-full lg:mx-1 lg:w-1/4'>
          <label className='mb-1 mt-3 block font-normal text-white' htmlFor='Location'>
            Flying from
          </label>
          <LocationDropdown location={location} />
          <div className='pointer-events-none absolute bottom-0 right-0 px-2 pb-4 text-gray-700'>
            <svg className='h-4 w-4 fill-current' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'>
              <path d='M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z' />
            </svg>
          </div>
        </div>
        <div className={`relative w-full lg:mx-1 lg:w-1/4`}>
          <label className='mb-1 mt-3 block font-normal text-white' htmlFor='RoomType[0]'>
            Room Type
          </label>
          <select name='RoomType[0]' id='RoomType[0]' className='block h-12 w-full appearance-none rounded-md border border-transparent bg-white py-3 px-4 text-gray-700'>
            <option value='D20'>Double - 2 adults</option>
            <option value='T20'>Twin - 2 adults</option>
            <option value='T11'>Twin - 1 adult 1 child</option>
            <option value='S10'>Single - 1 adult</option>
            <option value='T12'>Triple - 1 adult 2 children</option>
            <option value='T21'>Triple - 2 adults 1 child</option>
            <option value='T30'>Triple - 3 adults</option>
            <option value='F13'>Family - 1 adult 3 children</option>
            <option value='F22'>Family - 2 adults 2 children</option>
            <option value='F23'>Family - 2 adults 3 children</option>
            <option value='F31'>Family - 3 adults 1 child</option>
            <option value='F32'>Family - 3 adults 2 children</option>
          </select>
          {!isSecondRoom ? (
            <button type='button' onClick={() => secondRoom(true)} className='text-white font-normal flex items-center button-text border-b border-transparent hover:border-current mt-1'>
              <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='w-4 h-4'>
                <path strokeLinecap='round' strokeLinejoin='round' d='M12 6v12m6-6H6' />
              </svg>
              Add another room
            </button>
          ) : (
            <div className='relative w-full'>
              <button type='button' onClick={() => secondRoom(false)} className='text-white font-normal float-right mt-1.5'>
                <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={2.5} stroke='currentColor' className='w-4 h-4'>
                  <path strokeLinecap='round' strokeLinejoin='round' d='M6 18L18 6M6 6l12 12' />
                </svg>
                <span className='sr-only'>Remove</span>
              </button>
              <label className='mb-1 mt-3 block font-normal text-white' htmlFor='RoomType[1]'>
                Second room type
              </label>

              <select name='RoomType[1]' id='RoomType[1]' className='block h-12 w-full appearance-none rounded-md border border-transparent bg-white py-3 px-4 text-gray-700'>
                <option value='D20' selected='selected'>
                  Double - 2 adults
                </option>
                <option value='T20'>Twin - 2 adults</option>
                <option value='T11'>Twin - 1 adult 1 child</option>
                <option value='S10'>Single - 1 adult</option>
                <option value='T12'>Triple - 1 adult 2 children</option>
                <option value='T21'>Triple - 2 adults 1 child</option>
                <option value='T30'>Triple - 3 adults</option>
                <option value='F13'>Family - 1 adult 3 children</option>
                <option value='F22'>Family - 2 adults 2 children</option>
                <option value='F23'>Family - 2 adults 3 children</option>
                <option value='F31'>Family - 3 adults 1 child</option>
                <option value='F32'>Family - 3 adults 2 children</option>
              </select>
            </div>
          )}
        </div>
        <div className={`relative w-full lg:mx-1 lg:w-1/4`}>
          <label className='mb-1 mt-3 block font-normal text-white' htmlFor='ArrivalDate'>
            Hotel Check-in <small>(for 1 night)</small>
          </label>
          <input
            type='date'
            name='ArrivalDate'
            id='ArrivalDate'
            className='block h-12 w-full appearance-none rounded-md border border-transparent bg-white py-3 px-4 text-gray-700'
            defaultValue={defaultArrivalDate}
            min={defaultArrivalDate}
          />
        </div>
        <div className='relative w-full mt-10 lg:mx-1 lg:w-1/4'>
          <button href='#' className='button h-12 w-full'>
            Search
          </button>
        </div>
      </div>
    </form>
  )
}

Hotels.propTypes = {
  agentCode: PropTypes.string,
  location: PropTypes.string
}
export default React.memo(Hotels)
